import { CContainer } from "@coreui/react";
import React from "react";
import { ButtonBasic } from "src/components";

const CtaSection = () => {
  const scrollToTracks = () => {
    const tracks = document.getElementById("tracks");
    tracks.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="py-5">
      <CContainer className="container-sm px-5 text-center">
        <div
          style={{
            gap: "1.2rem",
          }}
          className="w-100 mx-auto  d-flex flex-column justify-content-center position-relative"
        >
          <h2 style={{ fontSize: "32px" }}>Get your ESG score today</h2>
          <p style={{ fontSize: "20px" }}>
            Demonstrate to your corporate customers your progress
          </p>
          <p style={{ fontSize: "20px" }}>
            Be included in ESG-aligned portfolios and supply chains
          </p>
          <p style={{ fontSize: "20px" }}>
            Have a clear roadmap for improvement across all the key areas
          </p>
          <ButtonBasic
            onClick={scrollToTracks}
            size="lg"
            bgcolor="green"
            hovercolor="darkgreen"
            style={{
              maxWidth: "300px",
            }}
            className={"my-3 w-100 mx-auto"}
          >
            Start now
          </ButtonBasic>
        </div>
      </CContainer>
    </section>
  );
};

export default CtaSection;
